import { render, staticRenderFns } from "./ModalAddRemark.vue?vue&type=template&id=a628e0e0"
import script from "./ModalAddRemark.vue?vue&type=script&lang=js"
export * from "./ModalAddRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports